import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid g-1" }
const _hoisted_2 = { class: "row row-cols-auto row_gap left__page-edge" }
const _hoisted_3 = {
  class: "col-12",
  style: {"margin-top":"10px"}
}
const _hoisted_4 = { class: "form__header" }
const _hoisted_5 = { class: "k-form wrapper__content" }
const _hoisted_6 = {
  key: 0,
  class: "row row-cols-auto row_gap left__page-edge align-items-end"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  class: "row row-cols-auto row_gap left__page-edge align-items-end",
  style: {"min-height":"64px!important"}
}
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  class: "row row-cols-auto row_gap left__page-edge align-items-end",
  style: {"min-height":"64px!important"}
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "row row-cols-auto justify-content-end button__dist" }
const _hoisted_13 = { class: "col save__min-width left__button" }
const _hoisted_14 = { style: {"display":"inline-block"} }
const _hoisted_15 = { style: {"display":"inline-block"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_kbutton = _resolveComponent("kbutton")!
  const _component_intl = _resolveComponent("intl")!
  const _component_localization = _resolveComponent("localization")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.backdropName)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.wrapperName),
          tabindex: "0"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_localization, { language: 'de-DE' }, {
              default: _withCtx(() => [
                _createVNode(_component_intl, { locale: 'de' }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.getPasswordTitle()), 1)
                      ])
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row row-cols-auto row_gap left__page-edge align-items-start" }, [
                      _createElementVNode("div", {
                        class: "col-12",
                        style: {"margin-top":"10px"}
                      }, [
                        _createElementVNode("label", { style: {"font-size":"12px","text-align":"left","padding-left":"8px","padding-right":"8px"} }, "Das Kennwort muss mindestens 8 Zeichen lang sein und mindestens eine Ziffer, einen Großbuchstaben, einen Kleinbuchstaben und ein Sonderzeichen (! @ # $ % ^ & * _ ? -) enthalten.")
                      ])
                    ], -1)),
                    _createElementVNode("form", _hoisted_5, [
                      (_ctx.mode === 'change' && !_ctx.isAdminMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_k_input, {
                                type: "password",
                                label: "Aktuelles Kennwort",
                                autocomplete: "off",
                                style: {width: '100%'},
                                tabIndex: 1,
                                "show-validation-icon": false,
                                modelValue: _ctx.passwordRef.data.kennwort,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordRef.data.kennwort) = $event)),
                                onPaste: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_k_input, {
                            type: "password",
                            label: "Neues Kennwort",
                            autocomplete: "off",
                            style: {width: '100%'},
                            tabIndex: 1,
                            "show-validation-icon": false,
                            modelValue: _ctx.passwordRef.data.kennwortNeu,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordRef.data.kennwortNeu) = $event)),
                            onPaste: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_k_input, {
                            type: "password",
                            label: "Bestätigung Kennwort",
                            autocomplete: "off",
                            style: {width: '100%'},
                            tabIndex: 1,
                            "show-validation-icon": false,
                            modelValue: _ctx.passwordRef.data.kennwortVergleich,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordRef.data.kennwortVergleich) = $event)),
                            onPaste: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"height":"42px"} }, null, -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_kbutton, {
                              onClick: _withModifiers(_ctx.onPasswordCancel, ["prevent"]),
                              icon: 'cancel',
                              "theme-color": 'primary',
                              size: 'medium',
                              class: _normalizeClass('save__size')
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("Abbrechen")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"display":"inline-block","width":"22px"} }, null, -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_kbutton, {
                              onClick: _withModifiers(_ctx.onPasswordChange, ["prevent"]),
                              icon: 'save',
                              "theme-color": 'primary',
                              size: 'medium',
                              class: _normalizeClass('save__size')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getPasswordTitle()), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}